var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinanceLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 45,
    viewBox: "0 0 224 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11251)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7013 18.8247L22.4024 10.1271L31.1071 18.8318L36.1671 13.7682L22.4024 0L8.6377 13.7647L13.7013 18.8247Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00195312 22.4004L5.05976 17.3387L10.1215 22.4004L5.05976 27.4621L-0.00195312 22.4004Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7005 25.9762L22.4017 34.6773L31.1063 25.9727L36.1699 31.0291L36.1663 31.0327L22.4017 44.8009L8.63696 31.0398L8.62988 31.0327L13.7005 25.9762Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6738 22.4023L39.7355 17.3406L44.7973 22.4023L39.7355 27.4641L34.6738 22.4023Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5365 22.3976L22.4022 17.2598L18.6054 21.0566L18.1666 21.4918L17.2678 22.3906L17.2607 22.3976L17.2678 22.4083L22.4022 27.5391L27.5365 22.4012L27.54 22.3976H27.5365Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6953 10.8555H63.7071C66.4388 10.8555 68.5052 11.5632 69.9065 12.9786C70.4344 13.5014 70.8506 14.126 71.1298 14.8146C71.409 15.5032 71.5454 16.2413 71.5307 16.9841V17.0513C71.5401 17.6599 71.4554 18.2663 71.2794 18.8489C71.1227 19.3505 70.8951 19.8271 70.6036 20.2643C70.3318 20.6766 70.003 21.0483 69.6269 21.3683C69.2595 21.6845 68.857 21.9576 68.4274 22.1821C69.6664 22.6137 70.7806 23.3427 71.6722 24.3052C72.4601 25.2016 72.854 26.4401 72.854 28.0206V28.0879C72.8764 29.075 72.6616 30.053 72.2277 30.9399C71.8073 31.757 71.1909 32.4573 70.4337 32.978C69.5777 33.552 68.6245 33.9656 67.6206 34.1988C66.4279 34.4817 65.2052 34.6183 63.9795 34.6058H52.6953V10.8555ZM62.6031 20.4589C63.5558 20.5049 64.5039 20.3 65.3525 19.8644C65.6834 19.6711 65.9536 19.389 66.1324 19.0501C66.3113 18.7111 66.3917 18.3289 66.3645 17.9466V17.8794C66.382 17.5271 66.3104 17.1761 66.1564 16.8589C66.0024 16.5416 65.771 16.2683 65.4834 16.0641C64.896 15.6466 64.0479 15.4378 62.9392 15.4378H57.7872V20.4589H62.6031ZM63.9937 30.0305C64.9429 30.0837 65.8876 29.8665 66.7183 29.4042C67.0419 29.1963 67.3039 28.9054 67.4769 28.5619C67.6499 28.2184 67.7276 27.8347 67.702 27.4509V27.3837C67.7148 27.0189 67.6379 26.6566 67.4781 26.3284C67.3183 26.0002 67.0805 25.7162 66.7855 25.5012C66.1769 25.0294 65.1932 24.7935 63.8345 24.7935H57.7872V30.0305H63.9937Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4141 10.8555H84.6404V34.6128H79.4141V10.8555Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5488 10.8555H97.3682L108.507 25.4765V10.8555H113.666V34.6128H109.219L97.715 19.5106V34.6128H92.5488V10.8555Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.491 10.6855H134.304L144.484 34.6128H139.028L136.855 29.2838H126.809L124.637 34.6128H119.308L129.491 10.6855ZM134.99 24.6696L131.827 16.9628L128.678 24.6696H134.99Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.135 10.8555H154.954L166.086 25.4765V10.8555H171.245V34.6128H166.797L155.294 19.5106V34.6128H150.135V10.8555Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.055 35.0312C188.39 35.0455 186.738 34.7229 185.2 34.0829C183.753 33.4851 182.439 32.6036 181.337 31.4902C180.236 30.3769 179.368 29.0543 178.785 27.6004C178.17 26.0796 177.859 24.4532 177.869 22.8128V22.7456C177.841 19.5122 179.085 16.3975 181.333 14.0728C182.439 12.9372 183.763 12.0369 185.225 11.426C186.816 10.767 188.524 10.4383 190.246 10.46C191.265 10.4524 192.281 10.5436 193.282 10.7325C194.139 10.8944 194.976 11.1446 195.78 11.4791C196.511 11.7864 197.205 12.1733 197.85 12.6326C198.48 13.0806 199.072 13.5801 199.62 14.1259L196.297 17.9616C195.448 17.1783 194.495 16.5151 193.466 15.9906C192.455 15.5072 191.346 15.2649 190.225 15.2829C189.292 15.273 188.368 15.4616 187.514 15.8362C186.66 16.2107 185.895 16.7628 185.271 17.4556C184.652 18.1466 184.167 18.947 183.842 19.8157C183.501 20.7338 183.329 21.7061 183.336 22.6854V22.7527C183.332 23.7306 183.504 24.7012 183.842 25.6188C184.163 26.4907 184.643 27.2957 185.257 27.9932C185.876 28.6946 186.639 29.2547 187.494 29.6356C188.349 30.0166 189.275 30.2094 190.211 30.2012C191.402 30.2387 192.585 29.9823 193.654 29.4546C194.671 28.8999 195.612 28.2147 196.453 27.4164L199.779 30.7779C199.192 31.4154 198.556 32.0069 197.879 32.5472C197.213 33.0736 196.49 33.5234 195.724 33.8883C194.907 34.2727 194.047 34.5566 193.162 34.734C192.139 34.939 191.098 35.0386 190.055 35.0312Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.947 10.8555H223.827V15.505H211.089V20.3244H222.306V24.974H211.106V29.9633H224.004V34.6128H205.958L205.947 10.8555Z",
    fill: "#FEEB61"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_11251",
    x: 8.6377,
    y: 0,
    width: 28.5293,
    height: 19.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_11251",
    x: -0.00195312,
    y: 17.3379,
    width: 11.123,
    height: 11.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_11251",
    x: 8.62988,
    y: 25.9727,
    width: 28.54,
    height: 19.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_11251",
    x: 34.6738,
    y: 17.3398,
    width: 11.123,
    height: 11.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1_11251",
    x: 17.2607,
    y: 17.2598,
    width: 11.2793,
    height: 11.2793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1_11251",
    x: 52.6953,
    y: 10.8555,
    width: 21.1602,
    height: 24.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1_11251",
    x: 79.4141,
    y: 10.8555,
    width: 6.22656,
    height: 24.7578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1_11251",
    x: 92.5488,
    y: 10.8555,
    width: 22.1172,
    height: 24.7578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1_11251",
    x: 119.308,
    y: 10.6855,
    width: 26.1768,
    height: 24.9277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1_11251",
    x: 150.135,
    y: 10.8555,
    width: 22.1104,
    height: 24.7578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_1_11251",
    x: 177.868,
    y: 10.459,
    width: 22.9111,
    height: 25.5723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1_11251",
    x: 205.947,
    y: 10.8555,
    width: 19.0566,
    height: 24.7578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_11251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 44.8007,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogoHeader);
export default __webpack_public_path__ + "static/media/binance-logo-header.19addd222b9ac77a6c504f86d131fe92.svg";
export { ForwardRef as ReactComponent };